
    import React from 'react';
    import ReactDOM from 'react-dom';
    import { withStyles } from '@wix/native-components-infra';
    import EditorAppWrapper from '@wix/yoshi-flow-editor-runtime/build/esm/EditorAppWrapper.js';
    import Widget from '/home/builduser/work/7de8fbf09bf2a439/packages/bookings-form-widget/src/components/BookingsForm/Widget/index.tsx';
    import createController from '/home/builduser/work/7de8fbf09bf2a439/packages/bookings-form-widget/src/components/BookingsForm/controller.ts';
    import {
     createHttpClient, HttpProvider,
    } from '@wix/yoshi-flow-editor';
    

  import { initI18n as initI18n } from '@wix/yoshi-flow-editor-runtime/build/esm/i18next/init';



    
  var importedApp = {};

    var componentName = 'BookingsForm';
    var projectName = 'bookings-form-widget';
    var sentryConfig = {
      DSN: 'https://8a26eadef7db4e1f8c80ebbe1517ed8e@sentry.wixpress.com/1627',
      id: '8a26eadef7db4e1f8c80ebbe1517ed8e',
      projectName: 'bookings-form-widget',
      teamName: 'bookings',
    };
    import stylesParams from '/home/builduser/work/7de8fbf09bf2a439/packages/bookings-form-widget/src/components/BookingsForm/stylesParams.ts';
    var experimentsConfig = {"scopes":["test"]};
    var translationsConfig = {"icuEnabled":true,"defaultTranslationsPath":"/home/builduser/work/7de8fbf09bf2a439/packages/bookings-form-widget/src/assets/locales/messages_en.json","availableLanguages":["en","uk"]};
    var defaultTranslations = {"app.widget.welcome":"Welcome","app.settings.label":"Configure Widget","app.settings.tabs.main":"Main","app.settings.tabs.design":"Design","app.settings.defaults.greetingsPretext":"to"};
    var biConfig = {"owner":"@wix/bi-logger-editor-flow-template","visitor":"@wix/bi-logger-editor-flow-template","enableUniversalEvents":false};
    var appDefinitionId = "13d21c63-b5ec-5912-8397-c3a5ddb27a97";
    var componentId = "843711b9-314e-4cda-b498-2da02dea7db2";
    var localeDistPath = 'assets/locales';

    import biLogger from '/home/builduser/work/7de8fbf09bf2a439/node_modules/@wix/bi-logger-editor-flow-template/dist/src/index.js';
    
      import { hot } from '@wix/component-hot-loader';
      var UserComponent = hot(module, Widget);
    
    var EditorComponent = React.createElement(EditorAppWrapper, {
      UserComponent,
      appDefinitionId,
      componentId,
      name: componentName,
      sentryConfig: sentryConfig,
      experimentsConfig: experimentsConfig,
      translationsConfig: translationsConfig,
      defaultTranslations: defaultTranslations,
      projectName: projectName,
      biConfig: biConfig,
      biLogger: biLogger,
      stylesParams,
      userController: createController,
      customInitAppForPage: importedApp.initAppForPage,
      optionalDeps: {
        initI18n,
        withStylesHoc: withStyles,
        createHttpClient, HttpProvider,
      },
      localeDistPath: localeDistPath,
    });
    ReactDOM.render(EditorComponent, document.getElementById('root'));
